import { styled } from '@mui/material/styles';
import { Box } from 'shared/mui/Box';
import { Typography } from 'shared/mui/Typography';

export const GatewayRuleInfoWrapperStyled = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '2px',
  minWidth: 0,
  overflowWrap: 'anywhere',
});

export const GatewayRuleInfoNameStyled = styled(Box)({
  alignItems: 'center',
  display: 'flex',
  marginRight: '16px',
  minWidth: 0,
});

export const GatewayRuleInfoFieldsStyled = styled(Box)({
  columnGap: '16px',
  display: 'flex',
  flexWrap: 'wrap',
  fontSize: '14px',
  fontWeight: 500,
  minWidth: 0,
  rowGap: '2px',
});

export const GatewayRuleInfoFieldStyled = styled(Box)({
  alignItems: 'center',
  display: 'flex',
  whiteSpace: 'nowrap',
});

export const GatewayRuleInfoMerchantFieldStyled = styled(Box)({
  alignItems: 'center',
  display: 'flex',
  minWidth: 0,
});

export const GatewayRuleInfoLabelStyled = styled(Typography)({
  fontWeight: 500,
  marginRight: '5px',
  whiteSpace: 'nowrap',
});
